import { render, staticRenderFns } from "./DirectConnectedForm.vue?vue&type=template&id=61b42491&scoped=true&"
import script from "./DirectConnectedForm.vue?vue&type=script&lang=js&"
export * from "./DirectConnectedForm.vue?vue&type=script&lang=js&"
import style0 from "./DirectConnectedForm.vue?vue&type=style&index=0&id=61b42491&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b42491",
  null
  
)

export default component.exports